<template>
  <div class="flow-user-choose" :class="{ 'flow-user-choose-disabled': disabled  }">

    <el-tag v-for="item in value" :key="item.id" size="medium" :disable-transitions="false">{{item.name}}</el-tag>
    <el-button circle class="flow-user-choose-addButton" :disabled="disabled" icon="el-icon-plus" size="small"
      @click="addGeneral" />
    <!-- 通用选择器 弹窗 -->
    <el-dialog :title="placeholder" :visible.sync="generalSelectShow" :append-to-body="true" width="1000px" top="5vh">
      <el-row gutter="30">
        <!-- 搜索条件 -->
        <el-form :inline="true" :model="searchVal" label-width="80px">
          <el-form-item label="姓名">
            <el-input @input="mainTableReload" clearable v-model="searchVal.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="学工号">
            <el-input @input="mainTableReload" clearable v-model="searchVal.loginName" placeholder="请输入学工号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="mainTableReload">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row gutter="10">
        <el-col :span="multiSelect?19:24">
          <el-table ref="table" v-loading="tableLoading" element-loading-text="拼命加载中..." :data="tableData"
            height="400px" @cell-click="cellClick" :border="true" row-key="id" style="width: 100%">
            <!-- 空插槽 border -->
            <template slot="empty">
              <avue-empty></avue-empty>
            </template>
            <el-table-column align="center" fixed="left" width="50" type="selection" prop="id">
              <template slot-scope="{row}">
                <el-checkbox v-model="row.checked" @change="change(row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" show-overflow-tooltip label="姓名">
            </el-table-column>
            <el-table-column prop="orgName" show-overflow-tooltip label="部门">
            </el-table-column>
            <el-table-column prop="loginName" show-overflow-tooltip label="工号">
            </el-table-column>
          </el-table>
          <nav style="text-align: center;margin:10px 0">
            <el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="paging.currentPage || 1" :page-sizes="[15, 25, 35, 45]" :page-size="paging.pageSize"
              layout="total, sizes, pager, jumper" :total="paging.total  "></el-pagination>
          </nav>
        </el-col>
        <el-col span="5" v-if="multiSelect" style="padding-left:15px">
          <el-row>
            <p style="font-weight:600;font-size:15px">已经选择执行人</p>
          </el-row>
          <el-scrollbar style="height:450px;">
            <el-row>
              <el-col v-for="item in selectData" :key="item.id" span="24">
                <el-row gutter="20">
                  <el-col span="18" style="white-space:nowrap;overflow:hidden">{{item.name}}</el-col>
                  <el-col span="6"> <el-button type="text" icon="el-icon-circle-close" @click="deletes(item)"
                      style="padding:0;font-size:16px;color:#c5c6c8"></el-button></el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="24">
          <div style="text-align:center;margin-top:20px" class="btnGroup">
            <el-row>
              <el-col>
                <el-button @click="generalSelectShow = false">关 闭</el-button>
                <el-button style="margin-left:100px;" type="primary" @click="submit">确 认</el-button>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>
<script>
import { deepClone } from '@/framework/util/util.js'
export default {
  name: 'AvueFlowUserChoose',
  props: {
    // 已经选择的对象
    value: {
      type: Array,
      default: () => []
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 标题
    placeholder: {
      type: String,
      default: '请选择用户'
    },
    // 最大选择数量
    maxRows: {
      type: Number,
      default: 1
    }
  },
  computed: {
    // 是否多选
    multiSelect: function () {
      return this.maxRows >= 2
    }
  },
  data() {
    return {
      paging: {
        currentPage: 1,
        pageSizes: [15, 20, 25, 30],
        pageSize: 15,
        total: 0
      },
      // 选中的数据
      selectData: [],
      // 表格数据
      tableData: [],
      // 表格转圈
      tableLoading: false,
      searchVal: {

      },
      generalSelectShow: false,
      secondQuery: false
    }
  },
  methods: {
    deletes(item) {
      this.selectData = this.selectData.filter(i => i.id !== item.id)
      this.mainTableReload()
    },
    cellClick(row, column) {
      if (column.type !== 'selection') {
        row.checked = !row.checked
        this.change(row)
      }
    },
    change(item) {
      if (this.multiSelect) {
        if (item.checked) {
          if (this.selectData.length >= this.maxRows) {
            this.$message.info('超过最大数量限制。')
            item.checked = !item.checked
          } else {
            this.selectData.push(item)
          }
        } else {
          this.selectData = this.selectData.filter(i => i.id !== item.id)
        }
      } else {
        if (item.checked) {
          this.selectData = [item]
          this.tableData.forEach(q => {
            if (q.id !== item.id) {
              q.checked = false
            }
          })
        } else {
          this.selectData = []
        }
      }
    },
    handleSizeChange(size) {
      this.paging.pageSize = size
      this.mainTableReload()
    },
    handleCurrentChange(currentPage) {
      this.paging.currentPage = currentPage
      this.mainTableReload()
    },
    mainTableReload() {
      // 防抖处理
      if (this.tableLoading) {
        return (this.secondQuery = true)
      }
      this.tableLoading = true
      this.secondQuery = false
      setTimeout(() => {
        this.$http.post('/account/query', {
          entity: {
            loginName: this.searchVal.loginName || null,
            name: this.searchVal.name || null
          }
        }, {
          params: {
            pageSize: this.paging.pageSize,
            pageNum: this.paging.currentPage
          }
        }).then(response => {
          let selectData = this.selectData.map(item => item.id)
          response.data.records.forEach(item => {
            if (selectData.includes(item.id)) item.checked = true
            else item.checked = false
          })
          this.tableData = response.data.records
          this.paging.total = response.data.total
          this.tableLoading = false
          if (this.secondQuery) this.mainTableReload()
        }).catch(error => {
          this.tableLoading = false
          this.tableData = []
          this.$message.error(error.msg || error.message)
        })
      }, 500)
    },
    /** 添加 通用对象 */
    addGeneral() {
      if (!this.disabled) {
        this.selectData = this.value ? deepClone(this.value) : []
        this.mainTableReload()
        this.generalSelectShow = true
      }
    },
    submit() {
      this.value = this.selectData
      this.$emit('input', this.selectData)
      this.generalSelectShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(th .el-checkbox) {
  display: none;
}
:deep(.el-tag) {
  margin-left: 0.625rem;
}

:deep(tr .el-checkbox__inner) {
  border-radius: 0.625rem;
}
.flow-user-choose {
  width: 100%;
  font-size: 0.875rem;
  line-height: 2.5rem;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid #dcdfe6;
  &-addButton {
    margin-left: 0.625rem;
  }
  &-disabled {
    background-color: #f5f7fa !important;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }
}

// 修改选择器样式
:deep(.el-dialog) {
  .el-dialog__header {
    border-bottom: 1px solid #e0e4e7;
    padding-bottom: 1.25rem;
    .el-dialog__title {
      color: #4ca0ff;
    }
  }
  .el-dialog__body {
    // 表格部分
    .el-table.el-table--border {
      border: 0;
      &::after {
        width: 0;
      }
      &::before {
        z-index: 100;
      }
      th {
        border: 0;
      }
      thead {
        color: #333;
      }
      .el-checkbox__inner {
        border: 2px solid #d4d5d7;
      }
      .el-checkbox__inner::after {
        width: 0.4375rem;
        height: 0.4375rem;
        background: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border: 2px solid #fff;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #409eff;
        &::after {
          background: #409eff;
        }
      }

      .el-table__header-wrapper {
        font-weight: 700;
        font-size: 0.9375rem;
        border-bottom: 1px solid #e0e4e7;
        .el-table__header {
          thead {
            th.is-leaf {
              border: 0 !important;
              text-align: center;
            }
          }
        }
      }

      .el-table__body-wrapper {
        tbody {
          td {
            border: 0;
            text-align: center;
          }
        }
      }
      .el-table__fixed {
        border: 0;
        &::before {
          height: 0;
        }
        .el-table__fixed-body-wrapper {
          tbody {
            td {
              border: 0 !important;
              text-align: center;
            }
          }
        }
      }
    }
    // 分页器
    nav {
      margin-top: 1.25rem !important;
      span {
        font-size: 0.9375rem;
      }
      .el-pager {
        li,
        .number {
          font-size: 0.8125rem;
          background: #fff;
          border: 1px solid #d0d0d0;
          border-radius: 3px;
          // height:28px;
          // min-width: 28px;
          &.active {
            background: #4da2ff;
            color: #fff;
          }
        }
      }
      .el-pagination__sizes {
        .el-select {
          // top:-3px;
          .el-input__inner {
            height: 1.375rem;
          }
        }
      }
    }
    // 按钮组
    .btnGroup {
      button {
        padding: 0.8125rem 1.875rem;
        &:nth-child(1) {
          background: #e0e4e7;
          color: #606266;
        }
      }
    }
  }
}
</style>
